import { Component } from 'react';

import { Stage } from '@stratumn/atomic';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';

import { renderStageIcon } from '@/utils/stage';
import StageTraces from './traces/traces.stage';

class StageBox extends Component {
  static propTypes = {
    stage: PropTypes.object.isRequired,
    groupId: PropTypes.string.isRequired
  };

  state = {
    open: false
  };

  toggle = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  render = () => {
    const { stage, groupId } = this.props;
    const { open } = this.state;
    const icon = renderStageIcon(stage);
    return (
      <Stage
        expanded={open}
        header={stage.label}
        icon={icon}
        onClick={this.toggle}
        traceCount={stage.traces.totalCount}
      >
        <StageTraces groupId={groupId} stageId={stage.rowId} />
      </Stage>
    );
  };
}

export const fragments = {
  stage: gql`
    fragment StageBoxFragment on Stage {
      rowId
      label
      type
      action {
        key
        icon
      }
      traces(
        filter: {
          or: [
            { rowId: { includesInsensitive: $search } }
            { tags: { contains: [$search] } }
          ]
        }
      ) {
        totalCount
      }
    }
  `
};

export default StageBox;
